module.exports = __webpack_public_path__ + "img/xiazaiwenjian.58a6cacf.png";